export interface CustomerMasterData {
    customerId: number;
    name: string;
    customerName: string;
    email: string;
    productionDate: string | null;
    cultureCode: string;
    cultureCodes: string;
    departmentId: string;
    departmentCode: string;
    departmentName: string;
    productionResponsibleId: string;
    customerResponsibleId: string;
    implementationResponsibleId: string;    
    createdBy: string;
    numberOfLicenses: number;
    adminResourceAccess: string[];
    // storage config
    customerCanSkipStorageRequirement: boolean;
    storage: AzureStorageData;
    personalStorage: AzureStorageData;
    evLicense: string; // Guid as string for select input
}

export interface AzureStorageData {
    containerName: string;
    connectionString: string;
}

export interface CreateCustomerResponse {
    customerId: number;
    departmentId: string;
    name: string;
    customerName: string;
    subDomain: string;
    email: string;
    productionDate: string | null;
    consultantId: string;
    numberOfLicenses: number;
    cultureCode: string;
    cultureCodes: string;
    evLicense: string;
    // New fields
}

// Mirrors the backend TenantProvisioningStatus enum (serialized as its numeric value).
export enum TenantProvisioningStatus {
    DispatchingWorkflow = 0,
    WaitingForDb = 10,
    Seeding = 20,
    Completed = 30,
    Failed = 40,
}

// Response of GET /customer/{tenantId}/provisioning-status and POST /customer/{tenantId}/complete.
export interface ProvisioningStatus {
    tenantId: number;
    status: TenantProvisioningStatus;
    // True once the tenant DB is registered in Administration.TenantDatabase (workflow finished).
    isTenantDbReady: boolean;
    errorMessage: string | null;
    updatedOn: string;
    attemptCount: number;
}

export interface UpdateCustomerResponse {
    kundeId: number;
    name: string;
    email: string | null;
    numberOfLicenses: number;
    productionDate: string | null;
    cultureCode: string;
    cultureCodes: string;
    departmentId: string;
    productionResponsibleId: string;
    customerResponsibleId: string;
    createdBy: string;
}

export interface Consultant {
    id: string;
    name: string;
    email: string;
    isBoss: boolean;
}

export interface Culture {
    key: string;
    value: string;
    // UI Properties
    selected: boolean;
}

export interface Department {
    id: string;
    code: string;
    name: string;
}

export interface CustomerCompany {
    companyId: number;
    name: string;
    alias: string;
}

export interface Customer {
    departmentId: string;
    departmentCode: string;
    departmentName: string;
    customerId: number;
    customerGuid?: string;
    name: string;
    companies: CustomerCompany[];
    hasDatabase: boolean;
}

export interface CustomerCanDeleteResponse {
    canDelete: boolean;
    message: string;
    noOfCommpanies: number;
}

export interface Employee {
    id: string;
    name: string;
    email: string;
    departmentCode: string;
    departmentName: string;
}

//AdminResourceUpdate
export interface AdminResourceListUpdate {
    customerId : number;
    adminResourceGuids : string[];
}

export interface Company
{
    companyId: number;
    name: string;
    nameUrl: string;
    // ui helpers
    isEditing: boolean;
    isChanged: boolean;
    isSaving: boolean;
    isUrlChanged: boolean;
    // temp values
    tempName: string;
    tempNameUrl: string;
}

export interface Companytemplate {
    customerId: number;
    customerName: string;
    companyId: number;
    companyName: string;
}

export interface CompanyInfo {
    companyId: number;  
    customerId: number;  
    name: string;
    nameUrl: string;
    template: Companytemplate;
}

export interface UpdateCompanynameRequest {
    customerId: number;
    companyId: number;
    name: string;
    nameUrl: string;
}

export interface ImportCustomerSetupRequest
{
    environment: string;
    sourceCustomerId: number;
    targetCustomerId: number;
}

export interface ImportCustomerSetupResponse
{
    message: string;
    newCompanyIds: number[];
}

export interface GetCustomerEvAdminsResponse
{
    selectedAdmins: string[];
    systemAdmins: string[];
}

export interface SystemAdminInfo
{
    departmentCode: string;
    names: string[];
}